import { render, staticRenderFns } from "./FamilyReceiveMessageTable.vue?vue&type=template&id=1d694f8e&scoped=true&lang=pug"
import script from "./FamilyReceiveMessageTable.vue?vue&type=script&lang=ts"
export * from "./FamilyReceiveMessageTable.vue?vue&type=script&lang=ts"
import style0 from "./FamilyReceiveMessageTable.vue?vue&type=style&index=0&id=1d694f8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d694f8e",
  null
  
)

export default component.exports